<template>
	<div class="b-basketBtn" :class="blockClass">
		<template v-if="inBasket">
			<a :href="basketUrl"
			   class="b-basketBtn__link b-basketBtn__link_inBasket"
			   :class="{'loading': true === loading}">
				<span class="icon icon--check b-basketBtn__linkIcon b-basketBtn__linkIcon_inBasket"></span>
				<span class="b-basketBtn__title" v-html="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_IN_BASKET"></span>
			</a>
		</template>
		<template v-else>
			<a :href="detailUrl"
			   class="b-basketBtn__link b-basketBtn__link_toBasket"
			   :class="{'loading': true === loading}"
			   @click="onBasketClick"
			>
				<template v-if="stock.enable && stock.count === 0 && isViewStock">
					<span class="b-basketBtn__linkIcon b-basketBtn__linkIcon_toBasket b-basketBtn__linkIcon_wait">
						<svg><use
							xlink:href="/local/templates/redesign/app/assets/dist/icons/sprite.svg#icons--waiting"></use></svg>
					</span>
					<span class="b-basketBtn__title" v-html="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_BOOK"></span>
				</template>
				<template v-else>
					<span class="icon icon--basket b-basketBtn__linkIcon b-basketBtn__linkIcon_toBasket"></span>
					<span class="b-basketBtn__title" v-html="basketBtnText"></span>
				</template>
			</a>
		</template>

		<magnific-popup :config="{closeOnBgClick:false}"
		                ref="popupModal"
		                class="modal-content modal-w-1000 b-modal b-modal_order b-modal_stock"
		                v-if="stock.enable"
		>
			<div v-if="quantity > stock.count || stock.count == 0">
				<div class="b-order__subtitle b-title_center">
					<span v-if="stock.count == 0" v-html="modalTextNoStock()"></span>
					<span v-else-if="quantity > stock.count" v-html="modalText()"></span>
				</div>

				<div class="b-modal__footer b-modal__footer_col">

					<button
						v-if="stock.count == 0"
						type="button"
						class="b-btn b-btn_transparent b-modal__btn"
						v-html="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_CLOSE_POPUP"
						@click="closePopupNostock()"
					></button>
					<button
						type="button"
						class="b-btn b-btn_primary b-modal__btn"
						v-html="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_CHANGE_DATE"
						@click="onBasketClickChangeDate()"
					></button>
					<button
						v-else-if="quantity > stock.count"
						type="button"
						class="b-btn b-btn_transparent b-modal__btn"
						v-html="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_LESS_COUNT"
						@click="setMaxQuantity()"
					></button>
				</div>
			</div>
		</magnific-popup>
		<magnific-popup :config="{closeOnBgClick:false}"
						ref="popupModalChooseDate"
						class="modal-content modal-w-1000 b-modal b-modal_order b-modal_stock"
						v-if="stock.enable"
		>
			<div>
				<h5 class="b-order-confirm__title b-title_center b-title_section"
					v-html="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_CHOOSE_DATE"
				></h5>
				<div class="b-order__subtitle b-title_center" v-if="withSelectOrCountNotAvailable">
					<span v-html="(quantity > stock.count && stock.count > 0) ? modalText() : modalTextChangeDate()"></span>
				</div>

				<div class="b-form b-form_stock" :class="{'b-form_calendar': withSelectOrCountNotAvailable}">
					<template v-for="field in deliveryFields">
						<template v-if="field.TYPE == 'enum' && !withSelectOrCountNotAvailable">
							<form-field-select
								ref="field"
								:field-props="field"
								:value="field.VALUE"
								v-model="field.VALUE"
								@input="onSelectTimeType(field.VALUE);"
							></form-field-select>
						</template>
						<citrus-date-pick
							v-else-if="field.TYPE == 'date'"
							ref="field"
							:field-props="field"
							:value="field.VALUE"
							:format="'d.m.Y'"
							:year-hidden="true"
							:time-separated="true"
							:time-format="'H:i'"
							:params="params.DELIVERY_DATE_PARAMS"
							:time-params="params.DELIVERY_TIME_PARAMS"
							v-model="field.VALUE"
							v-show="canSetDeliveryTime || withSelectOrCountNotAvailable"
							@input="onSelectDate(field.ID, field.VALUE);"
							class="b-form__calendar_modal"
						></citrus-date-pick>
					</template>
				</div>

				<button
					type="button"
					class="b-btn b-btn_primary b-modal__btn"
					:disabled="!chosenDeliveryDate && !withSelectOrCountNotAvailable"
					v-html="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_CHOOSE"
					@click="saveDeliveryTimeResult()"
				></button>

				<p v-if="!getDeliveryTimeCookie()" v-html="modalTextDescription()" class="mt-25px"></p>
			</div>
		</magnific-popup>
	</div>
</template>
<script>
import {Vue} from "ui.vue";
import {store} from "citrus.vuex.store";

/**
 * Дефолтные параметры данных продукта
 *
 * available - товар доступен
 * can_buy - товар можно купить
 * currency - валюта цены товара
 * full - базовая цена на товар без скидок
 * in_basket - товар в корзине
 * price - цена с учетом скидок
 */
export const defaultPriceData = {
	available: true,
	can_buy: true,
	currency: 'RUB',
	full: 0,
	in_basket: false,
	price: 0
};


/**
 * Код куки, в которой хранятся выбранные настройки даты доставки
 * @type {string}
 */
const DELIVERY_TIME_CHECKED = "savedDeliveryTime";

export default {
	name: 'CitrusProductBasketButton',
	/**
	 * productId - идентификатор товара
	 * price - данные о цене
	 * showMobile - показывать доп.контент для мобильных устройств
	 * bindGlobalBasket - отправлять глобальные события
	 * basketUrl - ссылка на корзину
	 * hasSku - у товара есть торговые предложения
	 * storageType - код хранилища данных
	 * customText - свой текст для кнопки
	 */
	props: {
		productId: [Number, String],
		productName: [String],
		price: Object,
		blockClass: {
			type: String,
			required: false,
			default: ''
		},
		detailUrl: {
			type: String,
			required: false,
			default: ''
		},
		basketUrl: {
			type: String,
			required: false,
			default: '/order/'
		},
		showMobile: {
			type: Boolean,
			required: false,
			default: false
		},
		bindGlobalBasket: {
			type: Boolean,
			required: false,
			default: true
		},
		hasSku: {
			type: Boolean,
			required: false,
			default: false
		},
		storageType: {
			type: [String, Boolean],
			required: false,
			default: false
		},
		customText: {
			type: String,
			required: false,
			default: ""
		},
		/** количество для добавления в корзину */
		quantity: {
			type: Number,
			default: 1
		},
		metricGoal: {
			type: [Boolean, String],
			default: false
		},
		stock: {
			type: [Object, Array],
			default: function () {
				return {}
			}
		}
	},

	/**
	 * Подключение хранилища данных
	 */
	store,

	/**
	 * Изменяемые данные
	 *
	 * @return {Object}
	 */
	data() {
		return {
			priceData: defaultPriceData,
			defaultDateValue: "select_time",
			chosenDeliveryDate: false,
			deliveryFields: [],
			params: {
				/*"DELIVERY_DATE_PARAMS": {
					"defaultDate": "23.06.2023",
					"maxDate": "28.07.2023",
					"minDate": "23.07.2023"
				},
				"DELIVERY_TIME_PARAMS": {
					"defaultDate": "12:00",
					"maxTime": "21:00",
					"minTime": "09:00"
				}*/
			},
			canSetDeliveryTime: false,

			withSelectAlways: false
		};
	},

	watch: {
		price: {
			handler(newVal) {
				this.priceData = this.preparePriceData(newVal);
			},
			deep: true
		}
	},

	created() {
		this.priceData = this.preparePriceData(this.price);

		Vue.event.$on("Citrus.Vue.Product:addedToBasket:" + this.productId, this.onAfterAdd);
		Vue.event.$on("Citrus.Vue.Product:removedFromBasket:" + this.productId, this.onAfterRemove);

		if (this.bindGlobalBasket) {
			//BX.addCustomEvent("Citrus.Vue.Product:removedBasket", this.onAfterRemove);
		}
	},
	beforeDestroy() {
		Vue.event.$off("Citrus.Vue.Product:addedToBasket:" + this.productId, this.onAfterAdd);
		Vue.event.$off("Citrus.Vue.Product:removedFromBasket+" + this.productId, this.onAfterRemove);
	},

	computed: {

		/**
		 * Языковые фразы
		 *
		 * @return {ReadonlyArray<any>}
		 */
		loc() {
			return Vue.getFilteredPhrases("CITRUS_VUE_PRODUCT_BASKET_BUTTON_");
		},

		/**
		 * Лежит ли товар в корзине
		 *
		 * @return {Boolean}
		 */
		inBasket() {
			let inBasket = false;
			switch (this.storageType) {
				case 'vuex':
					inBasket = this.$store.getters['basket/check'](this.productId);
					break;
				case 'input':
					inBasket = true === this.priceData.in_basket;
					break;
				default:
					inBasket = false;
			}

			return inBasket;
		},

		basketBtnText() {
			if (this.customText.length > 0) {
				return this.customText;
			}

			if (this.priceData.price <= 0) {
				return this.loc['CITRUS_VUE_PRODUCT_BASKET_BUTTON_SHOW_DETAIL_PAGE'];
			}

			return (
				true === this.hasSku
					? this.loc['CITRUS_VUE_PRODUCT_BASKET_BUTTON_SHOW_DETAIL_PAGE']
					: this.loc['CITRUS_VUE_PRODUCT_BASKET_BUTTON_ADD_TO_BASKET']
			);
		},
		loading() {
			if (this.storageType == 'vuex') {
				return this.$store.getters['basket/loading'](this.productId);
			}

			return false;
		},
		isViewStock() {
			return this.$store.getters['basket/isViewStock'];
		},
		orderStock() {
			return this.$store.getters['basket/orderStock'];
		},
		withSelectOrCountNotAvailable() {
			if (this.withSelectAlways) {
				return false;
			}

			return this.stock.count === 0 || this.quantity > this.stock.count;
		}
	},

	methods: {

		/**
		 * Подготовка и перепроверка входных данных о товаре
		 *
		 * @param data
		 * @return {Object}
		 */
		preparePriceData(data) {
			if (typeof data !== 'object' || data === null) {
				return defaultPriceData;
			}

			let code, result = {};
			for (code in defaultPriceData) {
				if (!data.hasOwnProperty(code)) {
					result[code] = defaultPriceData[code];
					continue;
				}
				switch (typeof defaultPriceData[code]) {
					case "boolean":
						result[code] = (true === data[code] || 'true' === data[code]);
						break;
					case "string":
						result[code] = String(data[code]).trim();
						break;
					case "number":
					case "bigint":
						result[code] = Number(data[code]);
						break;
					case "object":
						result[code] = (data[code] !== null) ? data[code] : {};
						break;
					default:
						result[code] = defaultPriceData[code];
						break;
				}
			}

			return result;
		},

		/**
		 * Действия для добавления товара в корзину
		 * Изменяется содержимое хранилища о товарах в корзине и пробрасываются события об изменении корзины
		 */
		sendAdd() {
			switch (this.storageType) {
				case 'vuex':
					this.$store.dispatch('basket/add', {id: this.productId, quantity: this.quantity});
					break;
				default:
					this.priceData.in_basket = true;
					Vue.event.$emit("Citrus.Vue.Product:addedToBasket:" + this.productId, {
						basketItem: this.basketItem,
						name: "bx-catalog-product-buy"
					});

					BX.onCustomEvent("OnBasketChange");
			}

			// отправим данные по метрике
			if (this.metricGoal) {
				this.$gtag.event(this.metricGoal);
				this.$metrika.reachGoal(this.metricGoal);
			}
		},

		onAfterAdd(params) {
			if (true !== this.priceData.in_basket) {
				this.priceData.in_basket = true;
			}
			if (true !== this.priceData.can_buy) {
				this.priceData.can_buy = true;
			}
			if (params.hasOwnProperty("basketItem") && params.basketItem) {
				this.basketItem = params.basketItem;
			} else {
				this.basketItem = 0;
			}
		},

		/**
		 * Обработка действий после
		 */
		onAfterRemove() {
			if (true === this.priceData.in_basket) {
				this.priceData.in_basket = false;
			}

			this.basketItem = 0;
		},

		/**
		 * Клик по кнопке `Купить`
		 *
		 * @param e
		 */
		onBasketClick(e) {
			this.withSelectAlways = false;
			if (true !== this.priceData.can_buy || this.productId <= 0 || true === this.hasSku || this.priceData.price <= 0) {
				return;
			}
			if (e) {
				e.preventDefault();
			}

			// у товара не включены остатки
			// или уже выбрана дата достави и мы добавляем в корзину не больше, чем есть в наличии
			// - или доступное кол-во равно 0 и уже выбрана дата доставки и она не раньше доступной -  сразу добавление в корзину
			if(!this.stock.enable
				|| this.stock.enable && (
					( this.checkCookieDate()  && this.quantity <= this.stock.count && this.stock.count > 0)
					|| (this.stock.count === 0 && this.checkCookieDate() && !this.isDateInAvailableInterval( this.getDeliveryTimeCookie() ))
				)) {
				this.sendAdd();
			} else {
				if (this.$refs.hasOwnProperty("popupModal")) {

					if(!this.getDeliveryTimeCookie()) {
						this.openModalChooseDate(this.stock.count == 0 || this.quantity > this.stock.count);
						return;
					}

					if (this.stock.count == 0 || this.quantity > this.stock.count) {
						this.$refs.popupModal.openModal();
					} else {
						this.openModalChooseDate(false);
					}
				}
			}
		},
		checkCookieDate() {
			let savedDeliveryTime = this.getDeliveryTimeCookie();
			if (savedDeliveryTime === null || (savedDeliveryTime.DELIVERY_TIME === '' && savedDeliveryTime.PICKUP_TIME === '')) return false;

			return true;
		},
		openModalChooseDate(withSelectAlways = false, datetimeForReloadRestrictions = "") {
			this.withSelectAlways = withSelectAlways;
			if (this.deliveryFields.length == 0) {
				this.getDeliveryFields((response) => {
					this.deliveryFields = response.fields;

					this.params = Object.assign({}, response.options);

					this.openModalChooseDateInternal(datetimeForReloadRestrictions);
				})
			}
			else {
				this.openModalChooseDateInternal(datetimeForReloadRestrictions);
			}
		},
		openModalChooseDateInternal(datetimeForReloadRestrictions = "") {
			this.loadDateRestrictions(this.withSelectAlways || Object.keys(this.params).length == 0, datetimeForReloadRestrictions, () => {
				if (this.withSelectAlways) {
					//this.setDefaultDeliveryTimeInInput("now", `${this.params.DELIVERY_DATE_PARAMS.minDate} ${this.params.DELIVERY_TIME_PARAMS.minTime}`);
					this.setDefaultDeliveryTimeInInput("", ``);
				}
				else if (this.stock.count == 0 || this.quantity > this.stock.count) {
					this.params.DELIVERY_DATE_PARAMS.minDate = this.orderStock.min_date;
					this.params.DELIVERY_DATE_PARAMS.defaultDate = this.orderStock.min_date;
					this.params.DELIVERY_TIME_PARAMS.minTime = this.orderStock.min_time;
					this.params.DELIVERY_TIME_PARAMS.defaultDate = this.orderStock.min_time;

					this.setDefaultDeliveryTimeInInput(this.defaultDateValue, `${this.params.DELIVERY_DATE_PARAMS.minDate} ${this.params.DELIVERY_TIME_PARAMS.minTime}`);
				}

				this.$refs.popupModalChooseDate.openModal();
			});
		},
		loadDateRestrictions(needReload, datetime, callback) {
			if (!needReload) {
				callback();
				return;
			}

			// новые ограничения по выбранной дате
			BX.ajax.runAction('citrus:iiko.DeliveryDate.getSettings', {
				data: {
					datetime: datetime,
					location: null
				},
				enctype: 'multipart/form-data',
			}).then((response) => {
				if (!BX.type.isObjectLike(response.data)) {
					return;
				}

				this.params = response.data.options;

				callback();
			}).catch((response) => {
				console.error('citrus.job.requestFailure', response);
			});
		},
		onBasketClickChangeDate(e) {
			this.openModalChooseDate(false);
		},
		closePopupNostock() {
			this.$refs.popupModal.closeModal();
		},
		onSelectTimeType(value) {
			this.chosenDeliveryDate = true;
			this.canSetDeliveryTime = (value == 'select_time');
		},
		onSelectDate(id, value) {
			// новые ограничения по выбранной дате
			BX.ajax.runAction('citrus:iiko.DeliveryDate.getSettings', {
				data: {
					datetime: value,
					location: null
				},
				enctype: 'multipart/form-data',
			}).then((response) => {
				if (!BX.type.isObjectLike(response.data)) {
					return;
				}

				this.params = response.data.options;

				this.$store.dispatch('basket/setExcludedDates', response.data.options.EXCLUDED_DATES);

				if (this.stock.count == 0 || this.quantity > this.stock.count) {
					const minTimeStore = new Date("2021-09-25T"+this.orderStock.min_time + ":00");
					const minTime = new Date("2021-09-25T"+this.params.DELIVERY_TIME_PARAMS.minTime + ":00");
					console.log(minTimeStore, minTime);
					if (this.params.DELIVERY_DATE_PARAMS.defaultDate === this.orderStock.min_date && minTimeStore > minTime) {
						this.params.DELIVERY_DATE_PARAMS.minDate = this.orderStock.min_date;
						this.params.DELIVERY_DATE_PARAMS.defaultDate = this.orderStock.min_date;
						this.params.DELIVERY_TIME_PARAMS.minTime = this.orderStock.min_time;
						this.params.DELIVERY_TIME_PARAMS.defaultDate = this.orderStock.min_time;
					}
				}
			}).catch((response) => {
				console.error('citrus.job.requestFailure', response);
			});
		},
		// первоначальная загрузка настроек полей
		async getDeliveryFields(callback) {
			BX.ajax.runAction('citrus:iiko.DeliveryDate.getFields', {
				data: {
				},
				enctype: 'multipart/form-data',
			}).then((response) => {
				if (!BX.type.isObjectLike(response.data)) {
					return;
				}

				callback(response.data);
			}).catch((response) => {
				console.error('citrus.job.requestFailure', response);
			});
		},
		saveDeliveryTimeResult() {
			let result = this.getDateFieldValues();

			if (this.withSelectAlways && this.isDateInAvailableInterval(result)) {
				this.params = {};
				this.openModalChooseDate(false, `${this.orderStock.min_date} ${this.orderStock.min_time}`);
				return;
			}

			this.saveDateFieldsToCookie(result);
			this.sendAdd();
			this.$refs.popupModal.closeModal();
		},
		getDateFieldValues() {
			let result = {};

			for(let i = 0; i < this.deliveryFields.length; i++) {

				if(this.stock.count === 0 && this.deliveryFields[i].CODE === "DELIVERY_TIME") {
					result[this.deliveryFields[i].CODE] = this.defaultDateValue;
				} else {
					result[this.deliveryFields[i].CODE] = this.deliveryFields[i].VALUE;
				}
			}

			return result;
		},
		saveDateFieldsToCookie(result) {
			if(this.stock.count === 0) {
				this.$store.dispatch('basket/toggleViewStock', false);
			} else {
				this.changeViewStock(result);
			}

			BX.setCookie(DELIVERY_TIME_CHECKED, JSON.stringify(result), this.getCookieOptions());

			BX.onCustomEvent('changeDeliveryTimeFromButton', [result]);
		},
		// domain нужен, чтобы кука распространялась на поддомены тоже
		getCookieOptions() {
			return {path: BX.message("SITE_DIR"), domain: document.domain};
		},
		setDefaultDeliveryTimeInInput(type, datetime) {
			for(let i = 0; i < this.deliveryFields.length; i++) {
				if(this.deliveryFields[i].CODE === "DELIVERY_TIME") {
					this.deliveryFields[i].VALUE = type;
				} else if (this.deliveryFields[i].CODE === "PICKUP_TIME") {
					this.deliveryFields[i].VALUE = datetime;
				}
			}

			this.onSelectTimeType(type);
		},
		setMaxQuantity() {
			this.$store.dispatch('basket/change', {id: this.productId, quantity: this.stock.count});
			this.$refs.popupModal.closeModal();
		},
		changeViewStock(result) {
			let isCompareDate = this.isDateInAvailableInterval(result);
			this.$store.dispatch('basket/toggleViewStock', isCompareDate);
		},
		isDateInAvailableInterval(result) {
			let timeType = result.DELIVERY_TIME,
				pickupTime = result.PICKUP_TIME;

			if (timeType === 'now' || !pickupTime) {
				return true;
			}

			// ожидаемый формат получаемой даты 01.01.2023
			let chosenDateArray = pickupTime.split(' ');
			let chosenDate = chosenDateArray[0].split('.').reverse().join('-');
			let formattedChosenDate = chosenDate + 'T' + chosenDateArray[1];
			formattedChosenDate = new Date(formattedChosenDate);
			formattedChosenDate.setMinutes(formattedChosenDate.getMinutes() + this.$store.getters['basket/orderMakeMinutes']);

			let availableDate = this.orderStock.min_date.split('.').reverse().join('-');
			let formattedAvailableDate = availableDate + `T${this.orderStock.min_time}`;

			return formattedChosenDate.getTime() < new Date(formattedAvailableDate).getTime();
		},
		getDeliveryTimeCookie() {
			return BX.getCookie(DELIVERY_TIME_CHECKED) ? JSON.parse(BX.getCookie(DELIVERY_TIME_CHECKED)) : null;
		},
		modalText() {
			return BX.message.CITRUS_QUANTITY_TRACE_POPUP_LIMITED
				? BX.message.CITRUS_QUANTITY_TRACE_POPUP_LIMITED
					.replace("#MIN_DELIVERY_DATE#", `${this.orderStock.min_date} ${this.orderStock.min_time}` )
					.replace("#COUNT#", this.stock.count)
					.replace("#PRODUCT_NAME#", this.productName)
				: "";
		},
		modalTextNoStock() {
			return BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_STOCK
				? BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_STOCK.replace("#MIN_DELIVERY_DATE#", `${this.orderStock.min_date} ${this.orderStock.min_time}` )
				: "";
		},
		modalTextDescription() {
			return BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_STOCK_DESCRIPTION
				? BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_STOCK_DESCRIPTION
				: "";
		},
		modalTextChangeDate() {
			return BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_ENABLED
				? BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_ENABLED.replace("#MIN_DELIVERY_DATE#", this.orderStock.min_date)
				: "";
		},
	}
};
</script>